import DateTime from 'pkg/datetime';
import { centsToAmount } from 'pkg/numbers';

export const formatCentsAsCurrency = (
	cents: number,
	currency: string,
	currencyDisplay?: 'symbol' | 'code'
): string => formatToCurrency(centsToAmount(cents), currency, currencyDisplay);

export const formatToCurrency = (
	number: number,
	currency: string,
	currencyDisplay: 'symbol' | 'code' = 'symbol'
): string => {
	if (!currency || (!number && number !== 0)) {
		return '';
	}

	return number.toLocaleString(DateTime.getLocale(), {
		style: 'currency',
		currency,
		currencyDisplay,
		maximumFractionDigits: 3,
	});
};
